import { Injectable, Inject } from '@angular/core';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';

@Injectable({
  providedIn: 'root',
})
export class PowerService {
  constructor(@Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService) {}

  private userRoles: any;
  private menuInfo: any;

  checkLinkPower(link) {
    if (typeof this.menuInfo[link] === 'undefined') {
      return false;
    }
    if (this.menuInfo[link].hide == 1) {
      return false;
    }
    const tokenData = this.tokenService.get();
    const menuType = this.menuInfo[link].menu_type;
    let menuRoles = [];
    if (this.menuInfo[link].acl != null) {
      menuRoles = this.menuInfo[link].acl.split(',');
    }

    switch (menuType) {
      case 'sys':
        if (tokenData.tenant_id == 0 && tokenData.isadmin == 999) {
          return true;
        }
        break;
      default:
        // all
        if (tokenData.isadmin == 999) {
          return true;
        }
        break;
    }

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < menuRoles.length; i++) {
      // tslint:disable-next-line: prefer-for-of
      for (let l = 0; l < this.userRoles.length; l++) {
        if (menuRoles[i] === this.userRoles[l]) {
          return true;
        }
      }
    }
    return false;
  }

  setMenuPower(menuInfo, userRoles) {
    this.userRoles = userRoles;
    this.menuInfo = {};
    const menus = menuInfo.list;
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < menus.length; index++) {
      const linkInfo: any = {};
      linkInfo.hide = menus[index].hide;
      linkInfo.acl = menus[index].acl;
      linkInfo.menu_type = menus[index].menu_type;
      this.menuInfo[menus[index].link] = linkInfo;
    }
  }
}
